// Display only: quota admission and retained numeric fields stay server-owned.
export function accessState(block = {}) {
  const quota = ['USER_QUOTA_INSUFFICIENT', 'FAMILY_QUOTA_EXHAUSTED'].includes(block.reason);
  return {
    title: block.title || '暂时无法使用 Ai助理',
    message: block.displayMessage || block.message || '',
    resetText: quota ? block.resetText || '' : '',
    icon: quota ? 'gauge' : 'spark'
  };
}

export function accessStateLayout(width, height) {
  const available = Number(height) || 0;
  return { width: Math.max(0, Math.min(480, Number(width) || 0)),
    top: available < 360 ? 16 : Math.min(112, Math.max(36, Math.round(available * 0.16))) };
}
